import { AnyAction } from "redux";
import { SET_EDIT_SCHEDULE_REPORT_FORMATS_LOADED } from "../actions/loadingEditScheduleReportFormats";

export const loadingEditScheduleReportFormats = (state = false, action: AnyAction) => {
  switch (action.type) {
    case SET_EDIT_SCHEDULE_REPORT_FORMATS_LOADED:
      return action.editScheduleReportFormatsLoaded;
    default:
      return state;
  }
};

export default loadingEditScheduleReportFormats;
